import { useGraphQLMutation } from '@opengov/bnp-core';
import { graphql } from '../../../../../gql-generated/hasura';
import { HASURA_SERVICE_URL } from '../../../../../config/config';
import { customReportsQueryKeys } from './customReportsQueryKeys';

const CreateSpreadsheetMutation = graphql(`
  mutation CreateSpreadsheet($entityId: Int!, $name: String!, $publicationId: uuid!) {
    insert_spreadsheets_one(object: { entityId: $entityId, name: $name, publicationId: $publicationId }) {
      id
    }
  }
`);

export function useCreateSpreadsheet() {
  return useGraphQLMutation({
    mutationKey: customReportsQueryKeys.createSpreadsheet(),
    document: CreateSpreadsheetMutation,
    url: HASURA_SERVICE_URL
  });
}
